"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const surveyInputs = [
  {
    name: "domain",
    type: "string",
    required: true,
    defaultValue: "",
  },
  {
    name: "identifier",
    type: "string",
    required: true,
    defaultValue: "",
  },
] as const satisfies Inputs;

export const SurveyComponent: RegisteredComponent = {
  name: "Survey",
  component: dynamic(async () => withValidation(surveyInputs, (await import("./Survey")).Survey, "Survey")),
  inputs: surveyInputs,
};
